import React from 'react';

export default function VectorsIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill || '#6C757D'}
    >
      <path d="M18.277 8C18.624 8.596 19.262 9 20 9C21.104 9 22 8.104 22 7C22 5.896 21.104 5 20 5C19.262 5 18.624 5.404 18.277 6H16V4C16 3.447 15.553 3 15 3H9C8.448 3 8 3.447 8 4V6H5.723C5.376 5.404 4.738 5 4 5C2.896 5 2 5.896 2 7C2 8.104 2.896 9 4 9C4.738 9 5.376 8.596 5.723 8H8V8.369C5.133 9.84 4.318 12.534 4.091 14H3C2.448 14 2 14.447 2 15V19C2 19.553 2.448 20 3 20H7C7.552 20 8 19.553 8 19V15C8 14.447 7.552 14 7 14H6.123C6.32 13.041 6.841 11.594 8.208 10.582C8.391 10.829 8.669 11 9 11H15C15.331 11 15.61 10.829 15.792 10.581C17.165 11.594 17.687 13.039 17.881 14H17C16.447 14 16 14.447 16 15V19C16 19.553 16.447 20 17 20H21C21.553 20 22 19.553 22 19V15C22 14.447 21.553 14 21 14H19.908C19.681 12.534 18.866 9.839 16 8.368V8H18.277ZM6 18H4V16H6V18ZM20 18H18V16H20V18ZM14 9H10V8V6V5H14V9Z" />
    </svg>
  );
}
